import { render, staticRenderFns } from "./drinkWater.vue?vue&type=template&id=9d9f9e16&scoped=true&"
import script from "./drinkWater.vue?vue&type=script&lang=ts&"
export * from "./drinkWater.vue?vue&type=script&lang=ts&"
import style0 from "./drinkWater.vue?vue&type=style&index=0&id=9d9f9e16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d9f9e16",
  null
  
)

export default component.exports